import {
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';
import React from 'react';

import { IBrandSafetyRuleException } from '~/src/dash/api/brand-safety-rules';

// type for list of element
export interface IIncludeExcludeTableElement {
  included: boolean; // is element included or excluded
  title: string; // visible text on the table
  name: string; // name of the code
  ID: any; // ID
}

// component properties
class IProps {
  source: string; // used for conditional rendering
  statusChangeDisabled?: boolean; // determine if IconButton on each row for status can be toggled
  defaultStatusExclude?: boolean; // if status changed is disabled, it determine the default value of the include/exclude
  list: IIncludeExcludeTableElement[]; // list of element to display in the table
  handleChange: (newList: IIncludeExcludeTableElement[], title: string) => void; // change handler
  elementTitleHeader: string; // title for the elements' title row
  elementNameHeader: string; // additional name field for the element, optional
  handleOpenRuleTargetedExceptionDialog: (targetedExceptionIABCode: string) => void;
  brandSafetyRuleExceptions?: IBrandSafetyRuleException[]; // all brand safety rule exceptions
  hideStatus?: boolean; // don't display the element
  parentClassName: string;
}

class IState {}

export const SourceBrandSafetyRuleEdit = 'brand-safety-rule-edit';
export const SourceCampaignFormView = 'campaign-form-view';

export class IncludeExcludeTable extends React.Component<IProps, IState> {
  // component rendering
  render() {
    const { brandSafetyRuleExceptions } = this.props;

    return (
      <TableContainer
        component={Paper}
        style={{
          width: '600px',
        }}
      >
        <Table size={'medium'}>
          <TableHead>
            <TableRow>
              {/* TABLE HEADERS*/}
              {!this.props.hideStatus && <TableCell>Status</TableCell>}
              <TableCell>{this.props.elementTitleHeader}</TableCell>
              {this.props.elementNameHeader && (
                <TableCell>{this.props.elementNameHeader}</TableCell>
              )}

              {this.props.source === SourceBrandSafetyRuleEdit && <TableCell>Exceptions</TableCell>}

              <TableCell>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* TABLE CONTENT*/}
            {
              // for each list element
              this.props.list.map((element: IIncludeExcludeTableElement, index: number) => {
                const foundTargetedIABCategory =
                  brandSafetyRuleExceptions &&
                  brandSafetyRuleExceptions.find((brandSafetyRuleException) => {
                    return (
                      brandSafetyRuleException.TargetedIABExceptions.split(',').findIndex(
                        (iabException) => iabException === element.title,
                      ) !== -1
                    );
                  });
                return (
                  <TableRow>
                    {/* STATUS*/}
                    {!this.props.hideStatus && (
                      <TableCell>
                        <IconButton
                          disabled={!!this.props.statusChangeDisabled}
                          onClick={() => {
                            this.handleIncludeChange(index, element.title);
                          }}
                          style={{
                            height: '25px',
                            width: '52px',
                            fontSize: '15px',
                            color: 'black',
                          }}
                        >
                          {
                            this.props.statusChangeDisabled && this.props.defaultStatusExclude && (
                              <>Blocked</>
                            ) // if statusChange is disabled, status will be determined by default status
                          }
                          {this.props.statusChangeDisabled && !this.props.defaultStatusExclude && (
                            <>Allowed</>
                          )}
                          {
                            !this.props.statusChangeDisabled &&
                              (element.included ? ( // if statusChange is enabled, status will be determined by element.included
                                <>Blocked</> // element is included
                              ) : (
                                <>Allowed</>
                              )) // element is excluded
                          }
                        </IconButton>
                      </TableCell>
                    )}

                    {/* TITLE*/}
                    <TableCell
                      className={`cypress-${this.props.parentClassName}-includeexcludetable-text-${this.props.elementTitleHeader}-${element.ID}`}
                    >
                      {element.title}
                    </TableCell>

                    {/* CATEGORY*/}
                    {this.props.elementNameHeader && (
                      <TableCell
                        className={`cypress-${this.props.parentClassName}-includeexcludetable-text-${this.props.elementNameHeader}-${element.ID}`}
                      >
                        {element.name}
                      </TableCell>
                    )}

                    {/* VIEW EXCEPTIONS BUTTON*/}
                    {this.props.source === SourceBrandSafetyRuleEdit && (
                      <TableCell>
                        {foundTargetedIABCategory ? (
                          <Grid
                            onClick={() =>
                              this.props.handleOpenRuleTargetedExceptionDialog(element.title)
                            }
                            style={{ cursor: 'pointer' }}
                          >
                            <VisibilityOutlined />
                          </Grid>
                        ) : (
                          <Grid>
                            <VisibilityOutlined color='disabled' />
                          </Grid>
                        )}
                      </TableCell>
                    )}

                    {/* DELETE BUTTON*/}
                    <TableCell>
                      <IconButton
                        className={`cypress-${this.props.parentClassName}-includeexcludetable-button-delete-${this.props.elementTitleHeader}-${element.ID}`}
                        onClick={() => this.handleDelete(index, element.title)}
                        style={{ height: '25px', width: '25px' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  // handles the toggle between included/excluded on an element
  private handleIncludeChange(index: number, title: string) {
    const menuList = [...this.props.list];
    menuList[index].included = !menuList[index].included; // toggle included boolean
    this.props.handleChange(menuList, title); // callback
  }

  // handles the deletion of an element
  private handleDelete(index: number, title: string) {
    const menuList = [...this.props.list];
    menuList.splice(index, 1); // delete element
    this.props.handleChange(menuList, title); // callback
  }
}
